module.exports = __webpack_public_path__ + "assets/img/Google-Play-Button.99de472c.png";